module.exports = __webpack_public_path__ + "ipad-10-landscape.svg?895318efde3f59a75486cf2d357bb24f";